export default __webpack_public_path__ + "static/sunset-woman-car-d5a2c1744fcd077d34668d1af2a897a8.jpg";